module.exports = __webpack_public_path__ + "static/landingpage-hero-min-992952a36adf0fd76d8ab06b6a85c761.jpg";